import React from 'react'
import { Divider } from 'antd'

export const CotizacionTicketComanda = React.forwardRef((props, ref) => {
  const { getQuote } = props

  let flag = false
  if (getQuote?.notes) {
    JSON.parse(getQuote?.notes).forEach(element => {
      if (element) flag = true
    });
  }
  
  const currency = getQuote.store.company.currency.symbol

  return (
    <div ref={ref} style={{ textAlign: 'center' }} className='ticket-modal'>
      <br />
      {/* <img src="tendero-logo-lg.png" className={'login-logo-lg'} alt={'moocho'} /> */}
      <br />
      <h1 style={{ color: 'var(--tendero-green)', fontSize: 'xxx-large' }}>{'Comanda de Cotización'}</h1>
      {
        getQuote.quote_invoice.fel_hondura ? (
          <>
            <p>{`RTN: ${getQuote?.quote_invoice?.fel_hondura?.rtn}`}</p>
            <p>{`E-Mail: ${getQuote?.quote_invoice?.fel_hondura?.email}`}</p>
            <p>{`Tel: ${getQuote?.quote_invoice?.fel_hondura?.company.phone}`}</p>
            <br />
          </>
        ) : (
          <>
            <p>{`${getQuote?.company ? getQuote.company : getQuote?.store?.company?.name}`}</p>
            <p>{`${getQuote?.store?.company?.address}`}</p>
            <p>{`${getQuote?.nit ? getQuote.nit : getQuote?.store?.company?.nit}`}</p>
            <br />
            <p>{`${getQuote?.store?.name ? getQuote?.store?.name : getQuote?.store?.name}`}</p>
            {/* <p>{`Direccion: ${getQuote?.store?.address ? getQuote?.store?.address : getQuote?.store?.address}`}</p> */}
            <br />
          </>
        )
      }

      <p>{'Vendedor'}</p>
      <p>{getQuote?.creator?.name}</p>
      <p>{`Turno ${getQuote?.store_turn_id}`}</p>
      <br></br>
      <p>{'Cliente'}</p>
      <p>{getQuote?.client?.name}</p>
      <p>{getQuote?.client?.nit}</p>
      <br></br>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{getQuote?.date}</p>
        <p>{`Ticket No. ${getQuote?.id}`}</p>
      </div>
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <br />
      <div>
        <table className='ticket-modal' style={{ width: '-webkit-fill-available' }}>
          <tbody>
            {getQuote?.quote_details && getQuote?.quote_details?.map((data) => (
              <tr key={data.id} style={{ fontSize: 30, fontWeight: 900 }}>
                <td>{`- ${data.quantity}`}</td>
                <td style={{ display: 'flex', textTransform: 'none' }}>{data?.presentation?.description.substring(0, 40)}</td>
                <td>{data?.discount_amount !== 0 ? `- ${data?.discount_amount} ${currency}` : ''} </td>
                <td>{currency} {data?.price}</td>
                <td>{`${currency} ${(data?.quantity * (data?.price - (data?.price * data?.discount_amount) / 100)).toFixed(2)}`}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <br />
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p style={{ marginBottom: 0 }}>{'Total articulos: '}{getQuote?.quote_details?.reduce((acumulador, actual) => acumulador + parseInt(actual.quantity), 0)}</p>
        <p style={{ marginBottom: 0 }}>{'Total: '}{currency} {Number(getQuote?.total).toFixed(2)}</p>
      </div>
      <br />
      <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
      <br /> 
      {
        flag ? (
          <>
            <div style={{ textAlign: 'initial', marginLeft: '2rem' }} className='ticket-modal'>
              <p>{'Informaciones Adicionales:'}</p>
              {JSON.parse(getQuote?.notes).map((data, i) =>
                data ? <p key={i}>{`Nota ${i + 1}: ${data}`}</p> : null
              )}
            </div>
            <br />
            <Divider className={'divider-custom-margins-nav'} type={'horizontal'} />
          </>
        ) : (
          <></>
        )
      }
      <br />
      <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '2rem', marginRight: '2rem' }}>
        <p>{'Fecha de expiracion:'}</p>
        <p>{getQuote?.expiration_date}</p>
      </div>
    </div>
  );
});